import {Component, Input} from "@angular/core";
import {ExamSessionService} from "../../../shared/services/exam-session/exam-session.service";
import {ExamSession} from "../../../shared/models/examSession";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {take} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";


@Component({
    selector: "app-session-delete-confirmation-modal",
    templateUrl: "./session-delete-confirmation-modal.component.html",
    styleUrls: ["./session-delete-confirmation-modal.component.scss"]
})
export class SessionDeleteConfirmationModalComponent {

    @Input() examSession: ExamSession;
    submitting: boolean = false;

    constructor (
        public activeModal: NgbActiveModal,
        private examSessionService: ExamSessionService,
        private toastr: ToastrService
    ) {}

    submit () {
        this.submitting = true;
        this.examSessionService.destroy(this.examSession.id).pipe(take(1)).
            subscribe(
                () => {
                    this.submitting = false;
                    this.activeModal.close(this.examSession);
                },
                (err) => {
                    if (err.status === 597) {
                        this.toastr.error(
                            "Attention ! l'email de notification n'a pas pu être envoyé",
                            "Session supprimée"
                        );
                        this.activeModal.close(this.examSession);
                    } else {
                        this.toastr.error(
                            "Une erreur est survenue",
                            "Erreur"
                        );
                    }

                    this.submitting = false;
                    throw err;
                }
            );
    }

}
